import i18n from "@/i18n";

/**
 * Класс данных курса валют.
 */
export class Curs {
    /**
     * Код валюты
     */
    public CurrCode: string = "";
    /**
     * Название валюты
     */
    get NameCurs(): string {
        return i18n.t(`common.currencies.code${this.CurrCode}`).toString()
    }
    /**
     * Курс продажи
     */
    public SaleAmount: number = 0;
    /**
     * Курс покупки
     */
    public BuyAmount: number = 0;

    public constructor(currCode: string, saleAmount: string, bayAmount: string) {
        this.CurrCode = currCode;
        this.SaleAmount = parseFloat(saleAmount);
        this.BuyAmount = parseFloat(bayAmount);
    }
}

export class Curses {
    public RefreshTime: any = null

    public Curses: Array<Curs> = []

    public Halfs: any = null

    public constructor(src: any) {
        if (src) {
            this.RefreshTime = Date.now()
            const sale = src.Data.InnerData.Data["sale"];
            const buy = src.Data.InnerData.Data["buy"];

            if (!sale || !buy)
                return;

            for (const key in sale.Properties) {
                const saleVal = sale.Properties[key]
                const buyVal = buy.Properties[key]
                if (saleVal != 1 || buyVal != 1) {
                    this.Curses.push(new Curs(key, saleVal, buyVal))
                }
            }

            const arrCopy = this.Curses.slice()
            let first: any = this.Curses
            let second: any = []
            if (this.Curses.length > 1) {
                if (this.Curses.length % 2 == 0) {
                    second = arrCopy.splice(this.Curses.length / 2)
                    first = arrCopy

                } else {
                    second = arrCopy.splice((this.Curses.length + 1) / 2)
                    first = arrCopy
                }
            }
            this.Halfs = { first: first, second: second }
        }
    }
}
